<div class="container">
  <div class="d-flex justify-content-center">
    <app-mfs-service [mfdAnalysis]=mfdStaticAnalysis></app-mfs-service>
  </div>
  <!-- <div>
    <app-mfs-service [mfdAnalysis]=mfdDynamicAnalysis></app-mfs-service>
  </div> -->
</div>
